export default {
  categories_title: "Categories",
  search: "Search products",
  log_in: "Log in/Sign up",
  back: "Back",
  no_products: "No products found",
  profile: "Profile"
}
